import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Button, Card, Col, Row } from 'react-bootstrap';
import { CardContainer, Heading5 } from '../widgets';
import { getFarmSettings } from '../../actions/farm';
import { connectScaleSocket } from '../../actions/scale-socket';
import ScaleIcon from '../../../assets/images/target_eg.png';

export const SclaeWeight = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
    const planTypeId = useSelector(state => state.plan.selectedPlanType);
    const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
    const scaleSocket = useSelector(state => state.scaleSocket);

    const { remote_scale_socket = {} } = farmSettings || {};
    const isRemoteScaleEnable = (remote_scale_socket && remote_scale_socket.visible);

    useEffect(() => {
        if (isRemoteScaleEnable) {
            if (!window.scaleSocketClient) dispatch(connectScaleSocket());
        }
    }, [isRemoteScaleEnable]);

    const { socketConneted, runningWeight, grossOrNet, scaleAtStandStill } = useMemo(() => {
        const { isConnected, scaleWeightInfo } = scaleSocket;
        const { weight: scaleWeight, scale_at_standstill, gross_or_net } = scaleWeightInfo;
        return { socketConneted: isConnected, runningWeight: scaleWeight, scaleAtStandStill: scale_at_standstill, grossOrNet: gross_or_net }
    }, [scaleSocket]);

    useEffect(() => {
        if (farmId) {
            dispatch(getFarmSettings({ farm_uuid: farmId, plan_type_id: planTypeId }));
        }
    }, [farmId]);

    return (
        <CardContainer lg={10} md={10}>
            <Card className="card-list farm-list-view animate animate__zoomIn">
                <Card.Header>
                    <Card.Title>
                        <Row>
                            <Col>
                                <Heading5>Scale Weight</Heading5>
                            </Col>
                            <Col className="col-4 text-right">
                                <Button
                                    className="btn btn-sm"
                                    variant="danger"
                                    onClick={() => {
                                        const url = `/home/farm/${farmId}/map`;
                                        history.push(url);
                                    }}
                                >
                                    <i className="fa fa-times-circle mr-1" />
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Card.Title>
                </Card.Header>

                <Card.Body>
                    <Row className="justify-content-center align-items-center">
                        <Col lg={4} md={6} sm={10}>
                            <Card className="text-center border-0">
                                <Card.Img
                                    variant="top"
                                    src={ScaleIcon}
                                    alt="truck"
                                    className={`rounded-circle mx-auto mt-3 ${socketConneted && !scaleAtStandStill ? 'shake_me scale-weight' : 'text-success scale-weight'}`}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                                <Card.Body>
                                    <Card.Title className={`${socketConneted && !scaleAtStandStill ? 'shake_me scale-weight' : 'text-success scale-weight'}`}>{runningWeight}</Card.Title>
                                    <Card.Subtitle className="mb-2 text-muted">{(grossOrNet && grossOrNet === 'N') ? 'Net' : 'Gross'}</Card.Subtitle>
                                    <Card.Text>
                                        At stand Still : {!scaleAtStandStill ? 'No' : 'Yes'}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </CardContainer>
    )
}